// import React, { useState } from "react";

// const logger = {
//   log: (...args) => console.log(...args),
//   warn: (...args) => console.warn(...args),
//   error: (...args) => console.error(...args)
// };

// const validateForm = (config, formData) => {
//   const errors = {};
//   const fields = config.fields || [];

//   fields.forEach(field => {
//     const value = formData[field.id];

//     if (field.required && (!value || value === "")) {
//       errors[field.id] = field.errorMessages?.required || `${field.label || 'This field'} is required`;
//       return;
//     }

//     if (value && field.validation) {
//       if (field.validation.pattern) {
//         const regex = new RegExp(field.validation.pattern);
//         if (!regex.test(value)) {
//           errors[field.id] = field.errorMessages?.pattern || "Invalid format";
//         }
//       }

//       if (field.validation.minLength && value.length < field.validation.minLength) {
//         errors[field.id] = field.errorMessages?.minLength || `Minimum ${field.validation.minLength} characters required`;
//       }

//       if (field.validation.maxLength && value.length > field.validation.maxLength) {
//         errors[field.id] = field.errorMessages?.maxLength || `Maximum ${field.validation.maxLength} characters allowed`;
//       }

//       if (field.validation.min && parseFloat(value) < field.validation.min) {
//         errors[field.id] = field.errorMessages?.min || `Minimum value is ${field.validation.min}`;
//       }

//       if (field.validation.max && parseFloat(value) > field.validation.max) {
//         errors[field.id] = field.errorMessages?.max || `Maximum value is ${field.validation.max}`;
//       }
//     }
//   });

//   return {
//     valid: Object.keys(errors).length === 0,
//     errors
//   };
// };

// export const UniversalFormPreview = ({
//   component,
//   formConfig,
//   runtime = false,
//   onSubmit
// }) => {
//   const config = component?.specificAttrs || component || formConfig || {};

//   const {
//     title,
//     description,
//     submitLabel,
//     submitButtonText,
//     fields = [],
//     nestedComponents = [],
//     actions = [],
//   } = config;

//   const formFields = fields.length > 0 ? fields : nestedComponents;

//   const [formData, setFormData] = useState({});
//   const [formErrors, setFormErrors] = useState({});
//   const [submitting, setSubmitting] = useState(false);

//   logger.log(`[UniversalFormPreview] Rendered - mode: ${runtime ? "runtime" : "builder"}`);

//   const handleChange = (fieldId, value) => {
//     logger.log(`[UniversalFormPreview] Field changed: ${fieldId}`);
//     setFormData(prev => ({ ...prev, [fieldId]: value }));
//     setFormErrors(prev => ({ ...prev, [fieldId]: "" }));
//   };

//   const handleSubmit = async e => {
//     e.preventDefault();
//     setSubmitting(true);
//     setFormErrors({});
//     logger.log("[UniversalFormPreview] Form submit triggered");

//     try {
//       const { valid, errors } = validateForm({ fields: formFields }, formData);

//       if (!valid) {
//         logger.warn("[UniversalFormPreview] Validation failed", errors);
//         setFormErrors(errors);
//         setSubmitting(false);
//         return;
//       }

//       if (actions?.length > 0) {
//         logger.log("[UniversalFormPreview] Executing actions", actions);
//       } else {
//         logger.log("[UniversalFormPreview] No actions configured");
//       }

//       if (onSubmit) {
//         onSubmit({ success: true, formData });
//       }
//       alert("✅ Form submitted successfully!");
//       logger.log("[UniversalFormPreview] Submission complete");
//     } catch (error) {
//       logger.error("[UniversalFormPreview] Submit error:", error);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const renderFormField = field => {
//     const value = formData[field.id] ?? "";
//     const error = formErrors[field.id];
//     const fieldType = field.smartFieldType || field.type;

//     const isVisible = field.visibility !== false;
//     const isRequired = field.required || false;
//     const isReadOnly = field.advancedOptions?.makeReadOnlyWhen && field.advancedOptions.makeReadOnlyWhen !== "Always Editable";

//     const baseStyle = { marginBottom: "12px" };
//     const labelStyle = {
//       display: "block",
//       fontSize: "13px",
//       fontWeight: "500",
//       marginBottom: "4px",
//       color: "#374151"
//     };
//     const inputStyle = {
//       width: "100%",
//       padding: "8px",
//       border: error ? "1px solid #EF4444" : "1px solid #D1D5DB",
//       borderRadius: "6px",
//       fontSize: "14px"
//     };
//     const errorStyle = { fontSize: "12px", color: "#DC2626", marginTop: "4px" };

//     if (!isVisible) return null;

//     switch (fieldType) {
//       case "mudumbai_textOnly":
//       case "text":
//         return (
//           <div key={field.id} style={baseStyle}>
//             <label style={labelStyle}>
//               {field.label}
//               {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
//             </label>
//             <input
//               type="text"
//               value={value}
//               required={isRequired}
//               readOnly={isReadOnly}
//               onChange={e => handleChange(field.id, e.target.value)}
//               placeholder={field.placeholder || ""}
//               style={inputStyle}
//             />
//             {error && <div style={errorStyle}>{error}</div>}
//           </div>
//         );

//       case "mudumbai_emailOnly":
//       case "email":
//         return (
//           <div key={field.id} style={baseStyle}>
//             <label style={labelStyle}>
//               {field.label}
//               {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
//             </label>
//             <input
//               type="email"
//               value={value}
//               required={isRequired}
//               readOnly={isReadOnly}
//               onChange={e => handleChange(field.id, e.target.value)}
//               placeholder={field.placeholder || ""}
//               style={inputStyle}
//             />
//             {error && <div style={errorStyle}>{error}</div>}
//           </div>
//         );

//       case "mudumbai_phoneOnly":
//       case "tel":
//         return (
//           <div key={field.id} style={baseStyle}>
//             <label style={labelStyle}>
//               {field.label}
//               {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
//             </label>
//             <input
//               type="tel"
//               value={value}
//               required={isRequired}
//               readOnly={isReadOnly}
//               onChange={e => handleChange(field.id, e.target.value)}
//               placeholder={field.placeholder || ""}
//               style={inputStyle}
//             />
//             {error && <div style={errorStyle}>{error}</div>}
//           </div>
//         );

//       case "mudumbai_passwordOnly":
//       case "password":
//         return (
//           <div key={field.id} style={baseStyle}>
//             <label style={labelStyle}>
//               {field.label}
//               {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
//             </label>
//             <input
//               type="password"
//               value={value}
//               required={isRequired}
//               readOnly={isReadOnly}
//               onChange={e => handleChange(field.id, e.target.value)}
//               placeholder={field.placeholder || ""}
//               style={inputStyle}
//             />
//             {error && <div style={errorStyle}>{error}</div>}
//           </div>
//         );

//       case "mudumbai_numberOnly":
//       case "number":
//         return (
//           <div key={field.id} style={baseStyle}>
//             <label style={labelStyle}>
//               {field.label}
//               {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
//             </label>
//             <input
//               type="number"
//               value={value}
//               required={isRequired}
//               readOnly={isReadOnly}
//               onChange={e => handleChange(field.id, e.target.value)}
//               placeholder={field.placeholder || ""}
//               style={inputStyle}
//             />
//             {error && <div style={errorStyle}>{error}</div>}
//           </div>
//         );

//       case "mudumbai_decimalOnly":
//       case "mudumbai_currencyOnly":
//       case "mudumbai_weightOnly":
//         return (
//           <div key={field.id} style={baseStyle}>
//             <label style={labelStyle}>
//               {field.label}
//               {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
//             </label>
//             <input
//               type="number"
//               value={value}
//               required={isRequired}
//               readOnly={isReadOnly}
//               step="any"
//               onChange={e => handleChange(field.id, e.target.value)}
//               placeholder={field.placeholder || ""}
//               style={inputStyle}
//             />
//             {error && <div style={errorStyle}>{error}</div>}
//           </div>
//         );

//       case "mudumbai_dateOnly":
//       case "date":
//         return (
//           <div key={field.id} style={baseStyle}>
//             <label style={labelStyle}>
//               {field.label}
//               {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
//             </label>
//             <input
//               type="date"
//               value={value}
//               required={isRequired}
//               readOnly={isReadOnly}
//               onChange={e => handleChange(field.id, e.target.value)}
//               placeholder={field.placeholder || ""}
//               style={inputStyle}
//             />
//             {error && <div style={errorStyle}>{error}</div>}
//           </div>
//         );

//       case "mudumbai_dateTime":
//       case "datetime-local":
//         return (
//           <div key={field.id} style={baseStyle}>
//             <label style={labelStyle}>
//               {field.label}
//               {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
//             </label>
//             <input
//               type="datetime-local"
//               value={value}
//               required={isRequired}
//               readOnly={isReadOnly}
//               onChange={e => handleChange(field.id, e.target.value)}
//               placeholder={field.placeholder || ""}
//               style={inputStyle}
//             />
//             {error && <div style={errorStyle}>{error}</div>}
//           </div>
//         );

//       case "mudumbai_textMultiline":
//       case "textarea":
//         return (
//           <div key={field.id} style={baseStyle}>
//             <label style={labelStyle}>
//               {field.label}
//               {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
//             </label>
//             <textarea
//               value={value}
//               required={isRequired}
//               readOnly={isReadOnly}
//               placeholder={field.placeholder}
//               onChange={e => handleChange(field.id, e.target.value)}
//               rows={field.rows || 4}
//               style={{ ...inputStyle, fontFamily: "inherit", resize: "vertical" }}
//             />
//             {error && <div style={errorStyle}>{error}</div>}
//           </div>
//         );

//       case "mudumbai_dropdown":
//       case "dropdown":
//       case "select":
//         const options = field.dataSource?.options || [];
//         return (
//           <div key={field.id} style={baseStyle}>
//             <label style={labelStyle}>
//               {field.label}
//               {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
//             </label>
//             <select
//               value={value}
//               disabled={isReadOnly}
//               required={isRequired}
//               onChange={e => handleChange(field.id, e.target.value)}
//               style={inputStyle}
//             >
//               <option value="">Select...</option>
//               {options.map((opt, idx) => (
//                 <option key={idx} value={opt}>
//                   {opt}
//                 </option>
//               ))}
//             </select>
//             {error && <div style={errorStyle}>{error}</div>}
//           </div>
//         );

//       case "mudumbai_checkbox":
//       case "checkbox":
//         return (
//           <div key={field.id} style={{ ...baseStyle, display: "flex", alignItems: "center", gap: "8px" }}>
//             <input
//               type="checkbox"
//               checked={!!value}
//               required={isRequired}
//               disabled={isReadOnly}
//               onChange={e => handleChange(field.id, e.target.checked)}
//               style={{ width: "16px", height: "16px" }}
//             />
//             <label style={{ fontSize: "14px", color: "#374151" }}>
//               {field.label}
//               {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
//             </label>
//             {error && <div style={errorStyle}>{error}</div>}
//           </div>
//         );

//       case "mudumbai_file":
//       case "file":
//         return (
//           <div key={field.id} style={baseStyle}>
//             <label style={labelStyle}>
//               {field.label}
//               {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
//             </label>
//             <input
//               type="file"
//               disabled={isReadOnly}
//               required={isRequired}
//               onChange={e => handleChange(field.id, e.target.files[0])}
//             />
//             {error && <div style={errorStyle}>{error}</div>}
//           </div>
//         );

//       default:
//         logger.warn(`[UniversalFormPreview] Unknown field type: ${fieldType}`);
//         return null;
//     }
//   };

//   return (
//     <form
//       onSubmit={handleSubmit}
//       style={{
//         border: "1px solid #E5E7EB",
//         borderRadius: "8px",
//         padding: "20px",
//         background: "#FFFFFF"
//       }}
//     >
//       {title && (
//         <h3 style={{
//           margin: "0 0 8px",
//           fontSize: "18px",
//           fontWeight: "600",
//           color: "#111827"
//         }}>
//           {title}
//         </h3>
//       )}
//       {description && (
//         <p style={{
//           margin: "0 0 20px",
//           fontSize: "14px",
//           color: "#6B7280",
//           lineHeight: "1.5"
//         }}>
//           {description}
//         </p>
//       )}

//       {formFields.length > 0 ? (
//         <div style={{ marginBottom: "20px" }}>
//           {formFields
//             .filter(field => field.visibility !== false)
//             .map(field => renderFormField(field))}
//         </div>
//       ) : (
//         <div style={{
//           padding: "24px",
//           textAlign: "center",
//           color: "#9CA3AF",
//           fontSize: "14px",
//           border: "1px dashed #D1D5DB",
//           borderRadius: "6px",
//           marginBottom: "20px"
//         }}>
//           No form fields configured yet
//         </div>
//       )}

//       <button
//         type="submit"
//         disabled={submitting}
//         style={{
//           width: "100%",
//           padding: "12px 20px",
//           background: submitting ? "#9CA3AF" : "#3B82F6",
//           color: "#FFFFFF",
//           border: "none",
//           borderRadius: "8px",
//           fontSize: "14px",
//           fontWeight: "600",
//           cursor: submitting ? "not-allowed" : "pointer",
//           transition: "background-color 0.2s"
//         }}
//       >
//         {submitting ? "Submitting..." : submitLabel || submitButtonText || "Submit"}
//       </button>
//     </form>
//   );
// };

// export default UniversalFormPreview;
// File: UniversalFormPreview.jsx
// Updated by Perplexity AI on 2025-11-02 14:09 IST to enable robust form validation using action system

import React, { useState } from "react";
// import { validateForm } from "../ActionSystem/utils/validationEngine"; // REMOVED: Old ActionSystem (2025-11-20)
// import actionRunner from "../ActionSystem/ActionRunner"; // REMOVED: Old ActionSystem (2025-11-20)
import { createLogger } from "../../utils/logger";

const logger = createLogger("src/components/FormBuilder/UniversalFormPreview.jsx");

export const UniversalFormPreview = ({ component, formConfig, runtime = false, onSubmit }) => {
  const config = component?.specificAttrs || component || formConfig || {};

  const {
    title,
    description,
    submitLabel,
    submitButtonText,
    fields = [],
    nestedComponents = [],
    actions = [],
  } = config;

  const formFields = fields.length > 0 ? fields : nestedComponents;

  const [formData, setFormData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  logger.info("render", "Form rendered", { mode: runtime ? "runtime" : "builder", fieldCount: formFields.length });

  const handleChange = (fieldId, value) => {
    logger.debug("handleChange", "Field value changed", { fieldId, valueLength: String(value).length });
    setFormData(prev => ({ ...prev, [fieldId]: value }));
    setFormErrors(prev => ({ ...prev, [fieldId]: "" }));
  };

  // Updated handleSubmit to run validation engine and actions properly
  const handleSubmit = async e => {
    e.preventDefault();
    setSubmitting(true);
    setFormErrors({});
    logger.entry("handleSubmit", { fieldCount: formFields.length, actionCount: actions?.length });

    try {
      // Run validation engine with full form fields and current data
      const { valid, errors } = validateForm({ fields: formFields }, formData);

      if (!valid) {
        logger.warn("handleSubmit", "Pre-validation failed", { errorCount: Object.keys(errors).length });
        setFormErrors(errors);
        setSubmitting(false);
        return;
      }

      // Run configured actions sequentially (includes "Validate Form" and others)
      if (actions?.length > 0) {
        logger.info("handleSubmit", "Executing action chain", { actionCount: actions.length });
        const result = await actionRunner.run(actions, {
          formData,
          fields: formFields,
          formConfig: { fields: formFields },
          setFormErrors,  // Pass setFormErrors to context for ValidateFormAction
          services: {
            toast: {
              show: (msg, opts) => {
                logger.info("handleSubmit", "Toast message", { message: msg });
                alert(msg);
              },
            },
            validator: { validate: validateForm },
          },
          meta: {
            pageId: runtime ? "runtime-page" : "builder-preview",
            componentId: component?.id || "preview",
            componentType: component?.type || "form",
          },
        });

        logger.info("handleSubmit", "Actions completed", { success: result.success, resultCount: result.results?.length });
        if (!result.success) {
          logger.warn("handleSubmit", "Some actions failed", result);
          // If validation failed inside action runner, update errors
          if (result.results) {
            const validationErrors = {};
            result.results.forEach(res => {
              if (!res.success && res.errors) {
                Object.assign(validationErrors, res.errors);
              }
            });
            if (Object.keys(validationErrors).length > 0) {
              setFormErrors(validationErrors);
              setSubmitting(false);
              return;
            }
          }
        }
      } else {
        logger.info("handleSubmit", "No actions configured - validation only");
      }

      // Callback for submit success (e.g., builder mode)
      if (onSubmit) {
        onSubmit({ success: true, formData });
      }

      alert("✅ Form submitted successfully!");
      logger.exit("handleSubmit", { success: true });
    } catch (error) {
      logger.error("handleSubmit", "Submit error", error);
    } finally {
      setSubmitting(false);
    }
  };

  // Render each form field with validation error display
  const renderFormField = (field) => {
    const value = formData[field.id] ?? "";
    const error = formErrors[field.id];
    const fieldType = field.smartFieldType || field.type;

    const isVisible = field.visibility !== false;
    const isRequired = field.required || false;
    const isReadOnly = field.advancedOptions?.makeReadOnlyWhen && field.advancedOptions.makeReadOnlyWhen !== "Always Editable";

    const baseStyle = { marginBottom: "12px" };
    const labelStyle = {
      display: "block",
      fontSize: "13px",
      fontWeight: "500",
      marginBottom: "4px",
      color: "#374151"
    };
    const inputStyle = {
      width: "100%",
      padding: "8px",
      border: error ? "1px solid #EF4444" : "1px solid #D1D5DB",
      borderRadius: "6px",
      fontSize: "14px"
    };
    const errorStyle = { fontSize: "12px", color: "#DC2626", marginTop: "4px" };

    if (!isVisible) return null;

    switch (fieldType) {
      case "mudumbai_textOnly":
      case "text":
        return (
          <div key={field.id} style={baseStyle}>
            <label style={labelStyle}>
              {field.label}
              {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
            </label>
            <input
              type="text"
              value={value}
              readOnly={isReadOnly}
              onChange={e => handleChange(field.id, e.target.value)}
              placeholder={field.placeholder || ""}
              style={inputStyle}
            />
            {error && <div style={errorStyle}>{error}</div>}
          </div>
        );

      case "mudumbai_emailOnly":
      case "email":
        return (
          <div key={field.id} style={baseStyle}>
            <label style={labelStyle}>
              {field.label}
              {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
            </label>
            <input
              type="email"
              value={value}
              readOnly={isReadOnly}
              onChange={e => handleChange(field.id, e.target.value)}
              placeholder={field.placeholder || ""}
              style={inputStyle}
            />
            {error && <div style={errorStyle}>{error}</div>}
          </div>
        );

      case "mudumbai_phoneOnly":
      case "tel":
        return (
          <div key={field.id} style={baseStyle}>
            <label style={labelStyle}>
              {field.label}
              {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
            </label>
            <input
              type="tel"
              value={value}
              readOnly={isReadOnly}
              onChange={e => handleChange(field.id, e.target.value)}
              placeholder={field.placeholder || ""}
              style={inputStyle}
            />
            {error && <div style={errorStyle}>{error}</div>}
          </div>
        );

      case "mudumbai_passwordOnly":
      case "password":
        return (
          <div key={field.id} style={baseStyle}>
            <label style={labelStyle}>
              {field.label}
              {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
            </label>
            <input
              type="password"
              value={value}
              readOnly={isReadOnly}
              onChange={e => handleChange(field.id, e.target.value)}
              placeholder={field.placeholder || ""}
              style={inputStyle}
            />
            {error && <div style={errorStyle}>{error}</div>}
          </div>
        );

      case "mudumbai_numberOnly":
      case "number":
        return (
          <div key={field.id} style={baseStyle}>
            <label style={labelStyle}>
              {field.label}
              {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
            </label>
            <input
              type="number"
              value={value}
              readOnly={isReadOnly}
              onChange={e => handleChange(field.id, e.target.value)}
              placeholder={field.placeholder || ""}
              style={inputStyle}
            />
            {error && <div style={errorStyle}>{error}</div>}
          </div>
        );

      case "mudumbai_decimalOnly":
      case "mudumbai_currencyOnly":
      case "mudumbai_weightOnly":
        return (
          <div key={field.id} style={baseStyle}>
            <label style={labelStyle}>
              {field.label}
              {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
            </label>
            <input
              type="number"
              value={value}
              readOnly={isReadOnly}
              step="any"
              onChange={e => handleChange(field.id, e.target.value)}
              placeholder={field.placeholder || ""}
              style={inputStyle}
            />
            {error && <div style={errorStyle}>{error}</div>}
          </div>
        );

      case "mudumbai_dateOnly":
      case "date":
        return (
          <div key={field.id} style={baseStyle}>
            <label style={labelStyle}>
              {field.label}
              {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
            </label>
            <input
              type="date"
              value={value}
              readOnly={isReadOnly}
              onChange={e => handleChange(field.id, e.target.value)}
              placeholder={field.placeholder || ""}
              style={inputStyle}
            />
            {error && <div style={errorStyle}>{error}</div>}
          </div>
        );

      case "mudumbai_dateTime":
      case "datetime-local":
        return (
          <div key={field.id} style={baseStyle}>
            <label style={labelStyle}>
              {field.label}
              {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
            </label>
            <input
              type="datetime-local"
              value={value}
              readOnly={isReadOnly}
              onChange={e => handleChange(field.id, e.target.value)}
              placeholder={field.placeholder || ""}
              style={inputStyle}
            />
            {error && <div style={errorStyle}>{error}</div>}
          </div>
        );

      case "mudumbai_textMultiline":
      case "textarea":
        return (
          <div key={field.id} style={baseStyle}>
            <label style={labelStyle}>
              {field.label}
              {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
            </label>
            <textarea
              value={value}
              readOnly={isReadOnly}
              placeholder={field.placeholder}
              onChange={e => handleChange(field.id, e.target.value)}
              rows={field.rows || 4}
              style={{ ...inputStyle, fontFamily: "inherit", resize: "vertical" }}
            />
            {error && <div style={errorStyle}>{error}</div>}
          </div>
        );

      case "mudumbai_dropdown":
      case "dropdown":
      case "select":
        const options = field.dataSource?.options || [];
        return (
          <div key={field.id} style={baseStyle}>
            <label style={labelStyle}>
              {field.label}
              {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
            </label>
            <select
              value={value}
              disabled={isReadOnly}
              onChange={e => handleChange(field.id, e.target.value)}
              style={inputStyle}
            >
              <option value="">Select...</option>
              {options.map((opt, idx) => (
                <option key={idx} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
            {error && <div style={errorStyle}>{error}</div>}
          </div>
        );

      case "mudumbai_checkbox":
      case "checkbox":
        return (
          <div key={field.id} style={{ ...baseStyle, display: "flex", alignItems: "center", gap: "8px" }}>
            <input
              type="checkbox"
              checked={!!value}
              disabled={isReadOnly}
              onChange={e => handleChange(field.id, e.target.checked)}
              style={{ width: "16px", height: "16px" }}
            />
            <label style={{ fontSize: "14px", color: "#374151" }}>
              {field.label}
              {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
            </label>
            {error && <div style={errorStyle}>{error}</div>}
          </div>
        );

      case "mudumbai_file":
      case "file":
        return (
          <div key={field.id} style={baseStyle}>
            <label style={labelStyle}>
              {field.label}
              {isRequired && <span style={{ color: "#EF4444", marginLeft: "4px" }}>*</span>}
            </label>
            <input
              type="file"
              disabled={isReadOnly}
              onChange={e => handleChange(field.id, e.target.files[0])}
            />
            {error && <div style={errorStyle}>{error}</div>}
          </div>
        );

      default:
        logger.warn("renderFormField", "Unknown field type", { fieldType, fieldId: field.id });
        return null;
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      noValidate // disable browser native validation to ensure custom validation triggers
      style={{
        border: "1px solid #E5E7EB",
        borderRadius: "8px",
        padding: "20px",
        background: "#FFFFFF",
      }}
    >
      {title && (
        <h3
          style={{
            margin: "0 0 8px",
            fontSize: "18px",
            fontWeight: "600",
            color: "#111827",
          }}
        >
          {title}
        </h3>
      )}
      {description && (
        <p
          style={{
            margin: "0 0 20px",
            fontSize: "14px",
            color: "#6B7280",
            lineHeight: "1.5",
          }}
        >
          {description}
        </p>
      )}

      {formFields.length > 0 ? (
        <div style={{ marginBottom: "20px" }}>
          {formFields
            .filter(field => field.visibility !== false)
            .map(field => renderFormField(field))}
        </div>
      ) : (
        <div
          style={{
            padding: "24px",
            textAlign: "center",
            color: "#9CA3AF",
            fontSize: "14px",
            border: "1px dashed #D1D5DB",
            borderRadius: "6px",
            marginBottom: "20px",
          }}
        >
          No form fields configured yet
        </div>
      )}

      <button
        type="submit"
        disabled={submitting}
        style={{
          width: "100%",
          padding: "12px 20px",
          background: submitting ? "#9CA3AF" : "#3B82F6",
          color: "#FFFFFF",
          border: "none",
          borderRadius: "8px",
          fontSize: "14px",
          fontWeight: "600",
          cursor: submitting ? "not-allowed" : "pointer",
          transition: "background-color 0.2s",
        }}
      >
        {submitting
          ? "Submitting..."
          : submitLabel || submitButtonText || "Submit"}
      </button>
    </form>
  );
};

// Default export for compatibility
export default UniversalFormPreview;
